import { render, staticRenderFns } from "./ManageCriteria.vue?vue&type=template&id=198298eb&"
import script from "./ManageCriteria.vue?vue&type=script&lang=js&"
export * from "./ManageCriteria.vue?vue&type=script&lang=js&"
import style0 from "./ManageCriteria.vue?vue&type=style&index=0&id=198298eb&prod&scopped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports